import { nodeType } from "../constants"

const initializePlainTextNode = (node, doAddPosition) => {
  if (node.type !== nodeType.plainText) {
    return node
  }

  let initializedNode = {
    type: node.type,
    value: node.value,
  }

  if (node.isStrictMatch) {
    initializedNode = {
      ...initializedNode,
      isStrictMatch: node.isStrictMatch,
    }
  }

  if (doAddPosition) {
    initializedNode = {
      ...initializedNode,
      startIndex: node.startIndex,
      endIndex: node.endIndex,
    }
  }

  return initializedNode
}

export const initializePlainTextNodes = (nodes, doAddPosition) => {
  let indexesToRemove = nodes.reduce((reducedIndexesToRemove, node, index) => {
    if (node.type !== nodeType.plainText) {
      return reducedIndexesToRemove
    }

    if (node.value.trim() === "") {
      return [...reducedIndexesToRemove, index]
    }

    return reducedIndexesToRemove
  }, [])
  return nodes
    .filter((node, index) => indexesToRemove.indexOf(index) === -1)
    .map((node) => initializePlainTextNode(node, doAddPosition))
}
